import "./Footer.scss"

type FooterProps = {
  style?: "light" | "dark"
}

function Footer(props: FooterProps) {
  return (
    <div className={`Footer Footer--${props.style}`}>
      <ul>
        <li>
          <a href="https://www.abtion.com/sikkerhedspolitik">
            Disclosure policy
          </a>
        </li>
      </ul>
    </div>
  )
}

export default Footer
